import React, { useCallback, useEffect, useState } from 'react'
import "./MatchMakingForm.css"
import ClayLayout from '@clayui/layout';
import MultiStep from '../../components/MultiStep/MultiStep';
import BasicInformationForm from './BasicInformationForm/BasicInformationForm';
import BusinessInformationForm from './BusinessInformationForm/BusinessInformationForm';
import OtpVerification from './OtpVerification/OtpVerification';
import { useDispatch } from 'react-redux';
import { setBusinessInformation } from '../../redux/slices/basicInformationSlice';
import FinalScreen from '../../generic-components/finalScreen/FinalScreen';
import Loader from '../../components/loader/Loader';

const MatchMakingForm = () => {
    const [step, setStep] = useState(0);
    const [formData, setFormData] = useState<{ [key: string]: any }>({});
    const [resStatusCode, setResStatusCode] = useState(2);
    const [resStatusMessage, setResStatusMessage] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const dispatch = useDispatch();

    const handleUpdateFormData = useCallback(
        (fieldName: string, value: any) => {
            setFormData((prev) => ({ ...prev, [fieldName]: value }));
        },
        []
    );

    useEffect(() => {
        if (step == 0) {
            dispatch(setBusinessInformation(formData));
        }
    }, [step]);

    return (
        <>
            {isLoading ? (
                <Loader />
            ) : (
                <div className="customer-wrapper">
                    <ClayLayout.ContentSection className="contact_container">
                        <ClayLayout.Row
                            justify="start"
                            className="contact_main"
                        >
                            {step !== 3 && (
                                <ClayLayout.Col
                                    sm={12}
                                    lg={11}
                                    className="contact_form p-0"
                                >
                                    <MultiStep step={step} setStep={setStep} />
                                </ClayLayout.Col>
                            )}
                            <ClayLayout.Col
                                sm={12}
                                lg={12}
                                className="contact_form p-0"
                            >
                                {step === 0 && (
                                    <div className="pr-0">
                                        <BasicInformationForm
                                            setStep={setStep}
                                            setIsLoading={setIsLoading}
                                        />
                                    </div>
                                )}
                                {step === 1 && (
                                    <OtpVerification setStep={setStep} />
                                )}
                                {step === 2 && (
                                    <div className="pr-0">
                                        <BusinessInformationForm
                                            setStep={setStep}
                                            formData={formData}
                                            setFormData={handleUpdateFormData}
                                            setResStatusCode={setResStatusCode}
                                            setResStatusMessage={
                                                setResStatusMessage
                                            }
                                            setIsLoading={setIsLoading}
                                        />
                                    </div>
                                )}
                                {step === 3 && (
                                    <FinalScreen
                                        resStatusMessage={resStatusMessage}
                                        resStatusCode={resStatusCode}
                                    />
                                )}
                            </ClayLayout.Col>
                        </ClayLayout.Row>
                    </ClayLayout.ContentSection>
                </div>
            )}
        </>
    );
};

export default MatchMakingForm